import { API_URL } from '../config/app';

/**
 * GET/POST JSON vers l’API Next. En dev, préférer API_URL vide + proxy Vite (`/api` → backend).
 */
export async function fetchJson<T>(path: string, init?: RequestInit): Promise<T> {
  const url =
    path.startsWith('http://') || path.startsWith('https://')
      ? path
      : `${API_URL}${path.startsWith('/') ? path : `/${path}`}`;

  const res = await fetch(url, init);
  const ct = res.headers.get('content-type') || '';

  if (!res.ok) {
    throw new Error(`HTTP ${res.status} sur ${url}`);
  }

  if (!ct.includes('application/json')) {
    const text = await res.text();
    throw new Error(
      `Réponse non-JSON (souvent du HTML). Vérifiez que le backend Next tourne (ex. port 3000) et qu’en dev le frontend utilise le port Vite 5173 avec proxy, ou définissez VITE_API_URL. Début : ${text.slice(0, 160)}`
    );
  }

  return res.json() as Promise<T>;
}
